import { Target, BarChart3, LineChart, MessageCircle, Lightbulb, CalendarDays, UserCog, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";

const ITEMS = [
  { icon: Target, label: "Kişiye özel yayın stratejisi" },
  { icon: BarChart3, label: "Profesyonel profil analizi" },
  { icon: LineChart, label: "Düzenli performans takibi" },
  { icon: MessageCircle, label: "Hızlı WhatsApp desteği" },
  { icon: Lightbulb, label: "Yayın ve içerik danışmanlığı" },
  { icon: CalendarDays, label: "Etkinlik ve kampanya desteği" },
  { icon: UserCog, label: "Kişiye özel menajer" },
  { icon: ShieldCheck, label: "Güvenilir ve şeffaf yönetim" },
];

export default function WhyUs() {
  return (
    <section id="neden-biz" data-testid="why-us-section" className="relative py-28 bg-[#050505]">
      <div className="absolute top-0 left-1/4 w-[400px] h-[400px] rounded-full bg-[#0047FF]/8 blur-[130px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="max-w-2xl mb-16">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Neden Hoom Agency?</span>
            <h2 className="font-display font-700 text-3xl md:text-4xl mt-4 text-white tracking-tight">
              Seni Farklı Kılan <span className="text-gradient">Avantajlar</span>
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((item, i) => (
            <Reveal key={item.label} delay={(i % 4) * 80}>
              <div
                data-testid={`why-us-card-${i}`}
                className="card-lift rounded-2xl border border-white/[0.07] bg-[#0A0E17] p-6 h-full"
              >
                <div className="w-10 h-10 rounded-lg bg-[#0047FF]/15 border border-cyan-400/20 flex items-center justify-center mb-5">
                  <item.icon size={18} strokeWidth={1.5} className="text-cyan-300" />
                </div>
                <p className="text-sm font-semibold text-white leading-snug">{item.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
